import React, { useState, useEffect } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  Image,
  ScrollView,
  Dimensions,
} from "react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";
import api from "../../services/api";
import HeaderTabs from "../../components/HeaderTabs";
import ScreenLoader from "../../components/ScreenLoader";
import styles from "./style";
import { FormattedMessage } from "react-intl";
import { If, Then, Else, When } from "react-if";
import GoBackButton from "../../components/GoBackButton";
import translationService from "../../services/translationService";
import CardsPacotesSelos from "../../components/CardsPacotesSelos";
import SelosSection from "../../components/SelosSection";
import SelosSectionMobile from "../../components/SelosSectionMobile";

export default function Marketplace({ route, navigation }) {
  const [actives, setActives] = useState([]);
  const [loading1, setLoading1] = useState(false);
  const [subcategories, setSubcategories] = useState([]);
  const [selectedSubcategory, setSelectedSubcategory] = useState(-1);
  const [translatedNames, setTranslatedNames] = useState({});
  const { categoryName } = route.params;
  useEffect(() => {
    getActives();
  }, []);
  const { width } = Dimensions.get("window");
  const [isSmallScreen, setIsSmallScreen] = useState(
    Dimensions.get("window").width < 1200
  );

  const getActives = async () => {
    const token = await AsyncStorage.getItem("JWT_TOKEN");
    const idActive = await AsyncStorage.getItem("id_category");

    setLoading1(true);
    api
      .get(`/actives/getActives/${idActive}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(async (res) => {
        const arrActives = [];
        const translations = [];
        for (const item of res.data.active) {
          const translatedName = await translationService.translate(
            item.name_token
          );
          translations[item.id] = translatedName;
          arrActives.push(item);
        }

        setTranslatedNames(translations);
        setLoading1(false);
        setActives(arrActives);
      })
      .catch((error) => {
        setLoading1(false);
        console.error(error);
      });
  };

  const selectedToken = async (id, categoryName) => {
    await AsyncStorage.setItem("id_coin", id + "");
    navigation.navigate("MoreInfosCoin", { id, categoryName });
  };

  return (
    <>
      <ScreenLoader loading={loading1} />

      <HeaderTabs
        title={<FormattedMessage id="marketplacecategories.titleMarketplace" />}
        subtitle={<FormattedMessage id="marketplacecategories.subtitulo" />}
      />

      <ScrollView>
        <View style={styles.containerBtnTodosAtivos}>
          {subcategories.map((el, index) => (
            <View key={index}>
              <TouchableOpacity
                onPress={() => setSelectedSubcategory(el.id)}
                style={[
                  styles.btnTodosOsAtivos,
                  selectedSubcategory === el.id
                    ? styles.selectedBtn
                    : styles.unselectedBtn,
                ]}
              >
                <Text
                  style={[
                    styles.textTodosOsAtivos,
                    el.id !== selectedSubcategory
                      ? styles.defaultText
                      : styles.selectedText,
                  ]}
                >
                  {el.name}
                </Text>
              </TouchableOpacity>
            </View>
          ))}
        </View>

        <When
          condition={
            typeof categoryName === "string" && !categoryName.includes("Selo")
          }
        >
          <View style={styles.token_container}>
            {actives.map((item) => {
              const subcategoryFilterMatch =
                !selectedSubcategory ||
                selectedSubcategory === -1 ||
                item.subcategories?.some?.(
                  (el) => el.id === selectedSubcategory
                );

              return (
                <When key={item.id} condition={subcategoryFilterMatch}>
                  <View style={styles.containerCard}>
                    <Image
                      source={{
                        uri: `https://filesgpx.s3.us-east-2.amazonaws.com/${item.path}`,
                      }}
                      style={styles.header_image}
                    />

                    <Image
                      source={{
                        uri: `https://filesgpx.s3.us-east-2.amazonaws.com/${item.path}`,
                      }}
                      style={styles.asset_icon}
                    />

                    <Text numberOfLines={2} style={styles.asset_name}>
                      {translatedNames[item.id] || item.name_token}
                    </Text>

                    <Text style={styles.token_price}>
                      <FormattedMessage id="marketplace.gpxBrl" />{" "}
                      {item.single_value.toFixed(2)}
                    </Text>

                    <TouchableOpacity
                      onPress={() =>
                        navigation.navigate("Purchase", {
                          viewType: "buy",
                          selectedActive: item.id,
                        })
                      }
                      style={styles.tokenBtnComprar}
                    >
                      <Text style={styles.tokenTextComprar}>
                        <FormattedMessage id="marketplace.comprar" />
                      </Text>
                    </TouchableOpacity>
                    {item.name_token.includes("USE") &&
                      (window.location.href.includes("localhost") ||
                        window.location.href.includes(
                          "homol.gpxecofi.com.br"
                        )) && (
                        <TouchableOpacity
                          style={[
                            styles.tokenBtnComprar,
                            styles.btncomprarMapa,
                          ]}
                          onPress={async () => {
                            try {
                              const token = await AsyncStorage.getItem(
                                "JWT_TOKEN"
                              );
                              if (token) {
                                const url = `https://api.homol.gpxecofi.com.br/gpx-agro-carbon?token=${token}`;
                                window.open(url, "_blank");
                              } else {
                                alert(
                                  "Sua sessão expirou. Por favor, faça login novamente."
                                );
                              }
                            } catch (error) {
                              console.error(
                                "Erro ao preparar o link para o mapa:",
                                error
                              );
                              alert(
                                "Ocorreu um erro ao tentar abrir o mapa. Tente novamente."
                              );
                            }
                          }}
                        >
                          <Text style={styles.textBtnMapa}>
                            <FormattedMessage id="marketplace.btnComprarMapa" />
                          </Text>
                        </TouchableOpacity>
                      )}
                    <TouchableOpacity
                      style={styles.tokenBtnDetalhes}
                      onPress={() => selectedToken(item.id, categoryName)}
                    >
                      <Text style={styles.tokenTextDetalhes}>
                        <FormattedMessage id="marketplace.detalhes" />
                      </Text>
                    </TouchableOpacity>
                  </View>
                </When>
              );
            })}
          </View>
        </When>
        <GoBackButton />
        <When
          condition={
            typeof categoryName === "string" && categoryName.includes("Selo")
          }
        >
          <CardsPacotesSelos />
          <If condition={isSmallScreen}>
            <Then>
              <SelosSectionMobile />
            </Then>
            <Else>
              <SelosSection />
            </Else>
          </If>
        </When>
      </ScrollView>
    </>
  );
}
